import { render, staticRenderFns } from "./ModalPagoComponent.vue?vue&type=template&id=64a68549"
import script from "./ModalPagoComponent.vue?vue&type=script&lang=js"
export * from "./ModalPagoComponent.vue?vue&type=script&lang=js"
import style0 from "./ModalPagoComponent.vue?vue&type=style&index=0&id=64a68549&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports